var InitTooltip = (function ($el, templateName) {
    if (!$el || !$el.length) return;

    var $content = $('<div class="info-label-popup"></div>');

    $el.append($content);

    $content.html($.tmpl('info-field', { InfoTemplateName: templateName }));
});